import { render, staticRenderFns } from "./nearbyItem.vue?vue&type=template&id=1e603882&scoped=true&"
import script from "./nearbyItem.vue?vue&type=script&lang=ts&"
export * from "./nearbyItem.vue?vue&type=script&lang=ts&"
import style0 from "./nearbyItem.vue?vue&type=style&index=0&id=1e603882&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e603882",
  null
  
)

export default component.exports